import { useMemo } from "react"

import { AvailableLocalHours } from "modules/Booking/components/TimeRequestModal/common/interfaces"
import * as utils from "utils/utils"

export function useHours(date: string | undefined, slots?: AvailableLocalHours) {
    return useMemo(() => {
        const hours = (date && slots && slots[utils.formatLocalDate(new Date(date))]) || []
        return hours.map((hour) => hour.localStart.split(" ")[0])
    }, [date, slots])
}
